module.exports = __webpack_public_path__ + "img/card-deposit.820b7dfa.svg";